import { SxProps } from "@mui/material";

export const sxInputBase: SxProps = {
  ml: 1,
  flex: 1
};

export const sxIconButton: SxProps = {
  p: '10px'
};